var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{ref:"redactor",attrs:{"name":_vm.name,"placeholder":_vm.placeholder},domProps:{"value":_vm.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }